import { useState } from 'react';
import { Alert } from '../../components/ui/Alert.tsx';
import { Button } from '../../components/ui/Button.tsx';
import { Brand, CenteredPage } from '../../components/ui/Layout.tsx';
import { useAuth } from '../../lib/auth.tsx';

/** Signed in, but the token carries no active workspace (and the user is not the platform owner). */
export function NoAccessPage() {
  const { claims, refresh, signOut } = useAuth();
  const [checking, setChecking] = useState(false);
  const [stillNone, setStillNone] = useState(false);

  async function checkAgain() {
    setChecking(true);
    try {
      await refresh();
      setStillNone(true);
    } finally {
      setChecking(false);
    }
  }

  return (
    <CenteredPage>
      <Brand />
      <h1 className="title">No workspace access</h1>
      <p className="callout text-ink-muted">
        You are signed in as <span className="font-medium">{claims?.email ?? 'unknown'}</span>, but
        this account is not an active member of any workspace.
      </p>
      <ul className="list-disc pl-5 callout text-ink-muted">
        <li>Invited? Open the link from your invitation, or ask your admin for a new one.</li>
        <li>Your access was removed? Ask your workspace admin.</li>
      </ul>
      {stillNone ? <Alert>Still no access for this account.</Alert> : null}
      <div className="flex flex-wrap gap-2">
        <Button variant="secondary" busy={checking} onClick={() => void checkAgain()}>
          Check again
        </Button>
        <Button variant="ghost" onClick={() => void signOut()}>
          Sign out
        </Button>
      </div>
    </CenteredPage>
  );
}
